/**
 * TODO: PREBUILD CONFIGURATION
 * 1. ENV
 * - API_URL
 * 
 */

export const NODE_ENV = process.env.NODE_ENV;
const isPROD = NODE_ENV === 'production';
const API_URL_DEV = 'http://localhost:8090';
const API_URL_PROD = process.env.REACT_APP_API_URL;
export const API_URL = isPROD ? API_URL_PROD : API_URL_DEV;